import swal from "sweetalert2";
import { getFileTypeForMimeType } from "utils/files.js";

export async function alertInvalidFileType(fieldName, fileType, allowedMimeTypes) {
	const uploaded = getFileTypeForMimeType(fileType);
	const accepted = allowedMimeTypes
		.map(mt => {
			const ft = getFileTypeForMimeType(mt);
			return ft.extension ? `${ft.name} (${ft.extension})` : ft.name;
		})
		.join(", ");

	try {
		await swal.fire({
			title: fieldName || "Invalid file type",
			html: `The file type "<strong>${uploaded.name}</strong>" is not allowed.<br/><br/>Accepted types: ${accepted}`,
			showCloseButton: true,
			type: "warning",
			confirmButtonColor: "#8CC541",
			confirmButtonText: "OK"
		});
	}catch(error) {
		return;
	}
}
